export function getCompanyIdFromUrl({ url }: { url: string }) {
  const urlObj = new URL(url);
  const pathSegments = urlObj.pathname.split("/");
  const lastSegment = pathSegments[pathSegments.length - 1];
  return Number(lastSegment);
}
